module.exports = __webpack_public_path__ + "static/media/onesland.8a45b61b.mov";